
import { defineComponent, PropType } from 'vue'
import MediaContainer from '@/components/MediaContainer.vue'
import MediaSizer from '@/components/MediaSizer.vue'

export default defineComponent({
  components: {
    MediaContainer,
    MediaSizer
  },
  props: {
    alt: String as PropType<string>,
    width: [String, Number] as PropType<string | number>, // Can be 'auto'.
    height: [String, Number] as PropType<string | number>, // Can be 'auto'.
    src: String,
    layout: {
      type: String as PropType<string>,
      default: 'responsive'
    },
    fill: String as PropType<string>
  }
})
